import environment from 'environment';
import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import HttpUtility from '../../utilities/HttpUtility';
import RegisterModel from '../_model/registerModel';
import EffectUtility from '../../utilities/EffectUtility';

export const registerEffect = {
  registerSet,
  requestError,
};

async function registerSet(payload) {
  const endpoint = environment.api.regMobile.replace(payload);
  const response = await HttpUtility.post(endpoint, payload);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  localStorage.setItem('customer', JSON.stringify(payload.Data));
  return response;
  // return response.data.map((json) => new RegisterModel(json));
}

/**
 * This is only to trigger an error api response so we can use it for an example in the AboutPage
 */
async function requestError() {
  const endpoint = environment.api.errorExample;
  const response = await HttpUtility.get(endpoint);

  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}
